export interface parsedDate {
    hours: number;
    minutes: number;
    seconds: number;

    day: number;
    month: number;
    year: number;
}

export function addPrefix(value: string): string {
    if (value.length === 1) return "0" + value;
    else return value;
}
export function lxDateToSpecFormat(date: any): string {
    return (
        date["year"] +
        "-" +
        addPrefix(String(date["month"])) +
        "-" +
        addPrefix(String(date["day"])) +
        " " +
        addPrefix(String(date["hour"])) +
        ":" +
        addPrefix(String(date["minute"]))
    );
}

export function lxDateToSpecFormatShort(date: any): string {
    return date["year"] + "-" + addPrefix(String(date["month"])) + "-" + addPrefix(String(date["day"]));
}

export function lxDateToTimeShort(date: any): string {
    return addPrefix(String(date["hour"])) + ":" + addPrefix(String(date["minute"]));
}

export function parseDateFormatted(value: string, separator?: string): parsedDate | any {
    let sep = "";

    sep = separator ? sep : ",";
    /*if (separator) {
        sep = String(separator);
    }*/

    let date = value.split(String(sep))[0];
    const time = value.split(String(sep))[1];
    let bFormat = false;

    if (date.indexOf("-") !== -1) bFormat = true;

    date = date.replaceAll("-", ".");


    try {

        if (String(time).indexOf(':')!==-1 && String(date).indexOf('.')!==-1) {
            if (!bFormat) {
                return {
                    hours: Number(time.split(":")[0]),
                    minutes: Number(time.split(":")[1]),
                    seconds: Number(time.split(":")[2]),

                    day: Number(date.split(".")[0]),
                    month: Number(date.split(".")[1]),
                    year: Number(date.split(".")[2]),
                };
            } else {
                return {
                    hours: Number(time.split(":")[0]),
                    minutes: Number(time.split(":")[1]),
                    seconds: Number(time.split(":")[2]),

                    day: Number(date.split(".")[2]),
                    month: Number(date.split(".")[1]),
                    year: Number(date.split(".")[0]),
                };
            }
        } else {
            console.log('parseDateFormatted неверное значение -'+value);
            return null
        }

    } catch (e) {
        console.log('parseDateFormatted error -'+e)
        return null

    }

}
